<template>
  <div id="education">
    <b-container style="margin-top: 100px; margin-bottom: 100px;">
      <b-row>
        <!-- <b-col lg="3" md="4" style="text-align: center;">
          Professional Experience
        </b-col> -->
        <b-col lg="12" md="12">
            
            <div style="margin-bottom: 50px;" v-scroll-reveal="{ delay: 100 }">
              <h2 class="section-title">Education</h2>
              <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
            </div>
            <div>

              <div v-scroll-reveal="{ delay: 100 }">
                <b-row>
                  <b-col lg="3" md="4" style="text-align: center;">
                    <img src="/uflogo.png" width="175"/>
                    <div class="uni" style="margin-bottom: 0px; margin-top: 20px;">Class of Fall 2018</div>
                    <div class="uni" style="margin-bottom: 0px; margin-top: 10px;">Political Science</div>
                    <div class="uni" style="margin-bottom: 40px; margin-top: 10px;">3.7 GPA</div>
                  </b-col>
                  <b-col lg="9" md="8">
                    <p class="section-subtitle" style=" font-size: 18px;">Overview</p>
                    <p>
                      I graduated from the University of Florida in 2022, where I earned my Bachelor's of Arts in Political Science. Throughout my studies I explored various global political landscapes, which enabled me to understand the complexities of different governance models and the impact of policies on societies. I'm enthusiastic about the prospect of working in an environment that values critical thinking, creativity, and a dedication to advancing societal well-being.
                    </p>
                    Took courses related to:
                    <ul style="padding-left: 40px; padding-top: 10px;">
                      <li>Research methods</li>
                      <li>Comparitive politics</li>
                      <li>Policy analysis</li>
                      <li>Government relations</li>
                      <li>International relations</li>
                      <li>Legal psychology</li>
                    </ul>
                    <p class="section-subtitle" style="margin-top: 50px; font-size: 18px;">Sorority Affiliation</p>
                    <p>I joined the Kappa Alpha Theta sorority my Sophomore year at UF through which I made connections with fellow students, participated in philanthropies, and developed interpersonal skills. Through interactions with fellow members, organizing events, and engaging with the school community as a whole, I developed leadership, relationship-building, and communication skills.</p>
                    
                  </b-col>
                </b-row>
              </div>
            </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
      skillItems: [
        {
          img: '/wordlogo.png',
          text: 'MS Word'
        },
        {
          img: '/excellogo.png',
          text: 'MS Excel'
        },
        {
          img: '/abacuslogo.png',
          text: 'Abacus Law'
        },
        {
          img: '/lexisnexis.png',
          text: 'Lexis Nexis'
        },
      ]
    }
  }
}
</script>

<style lang="css">



</style>
